











































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import KepatuhanJatuhStore from "@/store/modules/KepatuhanJatuhStore";

@Component
export default class RcaStep extends Vue {
  @Prop({ default: null }) session!: any;
  items: any[] = [];
  saving = false;
  error = "";

  metodeOpts = [
    { text: "5 Whys", value: "5_whys" },
    { text: "Fishbone", value: "fishbone" },
    { text: "Lainnya", value: "lainnya" }
  ];

  statusOpts = [
    { text: "Open", value: "open" },
    { text: "In Progress", value: "in_progress" },
    { text: "Closed", value: "closed" },
    { text: "Overdue", value: "overdue" }
  ];

  get store() {
    return KepatuhanJatuhStore;
  }

  @Watch("session", { immediate: true, deep: true })
  onSession(v: any) {
    this.items = v && v.rcas ? [...v.rcas] : [];
  }

  add() {
    this.items.push({
      nomor_urut: this.items.length + 1,
      masalah_gap: "",
      metode_rca: "5_whys",
      analisa_akar_masalah: "",
      rencana_tindak_lanjut: "",
      pic_nama: "",
      target_selesai: null,
      status_verifikasi: "open"
    });
  }

  remove(i: number) {
    this.items.splice(i, 1);
    // Re-number
    this.items.forEach((it, idx) => {
      it.nomor_urut = idx + 1;
    });
  }

  async save() {
    if (!this.session || !this.session.id) {
      this.$emit("next");
      return;
    }
    this.error = "";
    this.saving = true;
    try {
      await this.store.saveRca({ id: this.session.id, items: this.items });
      this.$emit("next");
    } catch (e) {
      this.error =
        e.response?.data?.message || e.message || "Gagal menyimpan RCA";
    } finally {
      this.saving = false;
    }
  }
}
